import init from "./src/controller";









window.addEventListener('load',init)